const W = 1080;
const H = 1350;
const INK = "#0b0b0a";
const BONE = "#ecebe6";
const ASH = "#a3a39c";
const SIGNAL = "#e5361b";

const wrap = (ctx, text, max) => {
  const words = text.split(/\s+/);
  const lines = [];
  let cur = "";
  words.forEach((w) => {
    const t = cur ? `${cur} ${w}` : w;
    if (ctx.measureText(t).width > max && cur) { lines.push(cur); cur = w; } else cur = t;
  });
  if (cur) lines.push(cur);
  return lines;
};

const grain = (ctx) => {
  const img = ctx.getImageData(0, 0, W, H);
  for (let i = 0; i < img.data.length; i += 4) {
    const n = (Math.random() - 0.5) * 18;
    img.data[i] += n; img.data[i + 1] += n; img.data[i + 2] += n;
  }
  ctx.putImageData(img, 0, 0);
};

function geometry(ctx) {
  ctx.strokeStyle = "rgba(236,235,230,0.10)";
  ctx.lineWidth = 1;
  for (let x = 0; x <= W; x += 90) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke(); }
  for (let y = 0; y <= H; y += 90) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke(); }
  const cx = W - 250, cy = 300;
  ctx.strokeStyle = "rgba(236,235,230,0.45)";
  [190, 140].forEach((r) => { ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.stroke(); });
  for (let i = 0; i < 72; i++) {
    const a = (i / 72) * Math.PI * 2, r1 = 190, r2 = i % 6 === 0 ? 172 : 182;
    ctx.beginPath(); ctx.moveTo(cx + Math.cos(a) * r1, cy + Math.sin(a) * r1); ctx.lineTo(cx + Math.cos(a) * r2, cy + Math.sin(a) * r2); ctx.stroke();
  }
  ctx.strokeStyle = BONE; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(cx - 100, cy - 90); ctx.lineTo(cx + 100, cy - 90); ctx.lineTo(cx, cy); ctx.closePath();
  ctx.moveTo(cx, cy); ctx.lineTo(cx + 100, cy + 90); ctx.lineTo(cx - 100, cy + 90); ctx.closePath(); ctx.stroke();
  ctx.strokeStyle = "rgba(236,235,230,0.6)"; ctx.lineWidth = 2.5; ctx.lineCap = "round";
  ctx.beginPath(); ctx.moveTo(40, 1010);
  ctx.bezierCurveTo(260, 900, 420, 1120, 620, 1000); ctx.bezierCurveTo(780, 905, 900, 1060, W - 40, 980); ctx.stroke();
  ctx.fillStyle = SIGNAL; ctx.beginPath(); ctx.arc(cx, cy, 9, 0, Math.PI * 2); ctx.fill();
}

export async function makeCard({ text, kicker, sub }) {
  await Promise.all([
    document.fonts.load('italic 300 60px "Newsreader"'),
    document.fonts.load('900 60px "Big Shoulders Display"'),
    document.fonts.load('400 24px "JetBrains Mono"'),
  ]).catch(() => null);
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = INK; ctx.fillRect(0, 0, W, H);
  geometry(ctx);
  ctx.fillStyle = ASH; ctx.font = '400 24px "JetBrains Mono", monospace';
  ctx.fillText(kicker.toUpperCase(), 80, 110);
  ctx.fillText(sub.toUpperCase().slice(0, 52), 80, 150);
  let size = 72;
  let lines;
  do {
    ctx.font = `italic 300 ${size}px "Newsreader", Georgia, serif`;
    lines = wrap(ctx, text, W - 160);
    size -= 4;
  } while (lines.length * size * 1.22 > 560 && size > 40);
  const lh = (size + 4) * 1.22;
  const top = Math.max(590, 640 - (lines.length * lh) / 2 + 60);
  ctx.fillStyle = BONE;
  lines.forEach((l, i) => ctx.fillText(l, 80, top + i * lh));
  ctx.fillStyle = BONE; ctx.font = '900 64px "Big Shoulders Display", Impact, sans-serif';
  ctx.fillText("OUTLAW CREATIVE", 80, H - 150);
  ctx.fillStyle = ASH; ctx.font = 'italic 400 34px "Newsreader", Georgia, serif';
  ctx.fillText("(the geometry of life)", 80, H - 100);
  ctx.fillStyle = SIGNAL; ctx.fillRect(W - 120, H - 162, 40, 4);
  grain(ctx);
  return new Promise((res) => c.toBlob(res, "image/png"));
}

export async function shareCard(card, filename, shareText) {
  const blob = await makeCard(card);
  const file = new File([blob], filename, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] })) {
    await navigator.share({ files: [file], title: card.kicker, text: shareText });
    return "shared";
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 4000);
  return "downloaded";
}
